/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

// Modules
import app from '@/store/app'
import appConfig from '@/store/app-config'
import verticalMenu from '@/store/vertical-menu'
import datas from '@/store/datas'
import account from '@/store/account'
import campaign from '@/store/campaign'
import auth from '@/store/auth'
import dashboard from '@/store/dashboard'
import report from '@/store/report'
import auction from '@/store/auction'
import finance from '@/store/finance'
import topup from '@/store/topup'
import domain from '@/store/domain'
import ratecard from '@/store/ratecard'
import navigation from '@/store/navigation'
import inbox from '@/store/inbox'
import tools from '@/store/tools'
import budget from '@/store/budget'
import userguide from '@/store/userguide'

const ls = new SecureLS({
  isCompression: false,
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    datas,
    account,
    auth,
    campaign,
    dashboard,
    report,
    auction,
    finance,
    topup,
    domain,
    ratecard,
    navigation,
    inbox,
    tools,
    budget,
    userguide,
  },
  state: {
    secretKey: 'mobilkoneng'
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key),
      },
    }),
  ],
  strict: process.env.DEV,
})
